<template>
  <div class="text-left">
    <v-list>
      <v-subheader
        v-if="heading"
        :class="headerClass"
      >
        {{ heading }}
      </v-subheader>
      <v-list-item
        v-for="(rule, key) in validationRules"
        :key="key"
        dense
        class="my-0 py-0"
      >
        <v-list-item-icon class="ma-0 pa-0">
          <v-icon
            v-if="fieldIsValid(key)"
            class="success--text"
            small
          >
            mdi-check-circle
          </v-icon>
          <div v-else>
            <v-icon
              :class="listItemClass(key)"
              small
            >
              mdi-circle-medium
            </v-icon>
          </div>
        </v-list-item-icon>
        <v-list-item-content class="ma-0 pa-0">
          <v-list-item-title :class="listItemClass(key)">
            {{ rule.label }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
export default {
  name: 'ValidationHelper',
  props: {
    value: {
      type: String,
      required: true
    },
    heading: {
      type: String,
      default: null
    },
    validationRules: {
      type: Object,
      required: true
    },
    fieldIsComplete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasErrors () {
      return Object.keys(this.validationRules).some(
        key => !this.fieldIsValid(key)
      )
    },
    headerClass () {
      return {
        'error--text': this.hasErrors && this.fieldIsComplete
      }
    }
  },
  methods: {
    fieldIsValid (key) {
      return this.validationRules[key].rule(this.value) === true
    },
    listItemClass (key) {
      return {
        'error--text': !this.fieldIsValid(key) && this.fieldIsComplete
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-subheader {
  height: auto;
}
.v-list-item {
  min-height: 0;
}
</style>
